import styled from "styled-components";

export const PageWrap = styled.main`
  width: 100%;
  overflow: visible;
  isolation: isolate;

  display: grid;
  gap: 28px;

  background: transparent;
  color: #0b0b0b;

  padding-top: 240px;

  @media (max-width: 940px) {
    padding-top: 150px;
  }

  @media (max-width: 520px) {
    padding-top: 132px;
  }
`;

export const Hero = styled.section`
  width: 100%;
  padding: 10px 0 70px;
  text-align: center;
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 64px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: none;
  color: #2a1f1f;

  @media (max-width: 768px) {
    font-size: 42px;
  }
`;

export const HeroSub = styled.p`
  margin: 18px auto 0;
  max-width: 780px;

  font-family: "Cormorant Garamond", serif;
  font-size: 22px;
  font-style: italic;
  line-height: 1.9;
  color: rgba(42, 31, 31, 0.62);

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const Section = styled.section`
  width: min(1100px, 92vw);
  margin: 0 auto;
`;

export const CompanyDetails = styled.section`
  width: min(1100px, 92vw);
  margin: 10px auto 80px;
  padding-top: 10px;
`;

export const CompanyDetailsInner = styled.div`
  text-align: center;
  padding: 5px 20px;
`;

export const CompanyTitle = styled.h2`
  margin: 0 0 16px;
  font-family: "Cormorant Garamond", serif;
  font-size: 34px;
  font-weight: 500;
  color: #2a1f1f;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const CompanyText = styled.p`
  margin: 8px 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 20px;
  line-height: 1.8;
  color: rgba(42, 31, 31, 0.78);

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;
